import { render, staticRenderFns } from "./customerBrandPackageList.vue?vue&type=template&id=4d6d87af&scoped=true"
import script from "./customerBrandPackageList.vue?vue&type=script&lang=ts"
export * from "./customerBrandPackageList.vue?vue&type=script&lang=ts"
import style0 from "./customerBrandPackageList.vue?vue&type=style&index=0&id=4d6d87af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6d87af",
  null
  
)

export default component.exports